module.exports = __webpack_public_path__ + "img/credit_debit.92685e90.png";